import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { Loader } from "mds";
import { fetchSession } from "screens/login/sessionThunk";
import { SessionCallStates } from "screens/login/sessionSlice.types";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const dispatch = useAppDispatch();
  const [componentLoading, setComponentLoading] = useState<boolean>(true);
  const sessionState = useSelector(
    (state: RootState) => state.session.sessionState,
  );
  const sessionLoadingState = useSelector(
    (state: RootState) => state.session.sessionLoadingState,
  );

  useEffect(() => {
    dispatch(fetchSession());
  }, [dispatch]);

  useEffect(() => {
    if (sessionLoadingState === SessionCallStates.Done) {
      setComponentLoading(false);
    }
  }, [dispatch, sessionLoadingState]);

  if (componentLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Loader />
      </div>
    );
  }

  if (sessionState === "invalid") {
    return <Navigate to="/login" />;
  }
  return children;
};

export default ProtectedRoute;
